import type { UploadStrategyType } from '../types.ts';

import { useUploadSingle } from './useUploadSingleStrategy.ts';
import { useUploadBulk } from './useUploadBulkStrategy.tsx';

export const useUploadStrategy = ({
	setCreatedDraftId,
	setImportedDraftPageData,
	setElementProcessingError,
	setIsCancelledDocumentsDeleted,
	currentSpace,
	restrictionType,
	parentPageId,
	handleUploadFileWithDiscard,
	setImportedPageData,
	importStrategyRef,
	subType,
	deleteOnboardingBlankPage,
}: {
	setCreatedDraftId: any;
	setImportedDraftPageData: any;
	setElementProcessingError: any;
	setIsCancelledDocumentsDeleted: any;
	currentSpace: any;
	restrictionType: any;
	parentPageId: any;
	handleUploadFileWithDiscard: any;
	setImportedPageData: any;
	importStrategyRef: any;
	subType: any;
	deleteOnboardingBlankPage: any;
}): ((isBulk: boolean) => UploadStrategyType) => {
	const singleStrategy = useUploadSingle(
		handleUploadFileWithDiscard,
		setCreatedDraftId,
		setImportedDraftPageData,
		setElementProcessingError,
		importStrategyRef,
		currentSpace,
		parentPageId,
		restrictionType,
		subType,
		setImportedPageData,
		deleteOnboardingBlankPage,
	);
	const bulkStrategy = useUploadBulk(
		setIsCancelledDocumentsDeleted,
		currentSpace,
		restrictionType,
		parentPageId,
		handleUploadFileWithDiscard,
		setImportedPageData,
		importStrategyRef,
		subType,
		deleteOnboardingBlankPage,
	);

	return (isBulk) => (isBulk ? bulkStrategy : singleStrategy);
};
